
















import Vue from 'vue'
export default Vue.extend({
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        img: {
            type: Boolean,
            default: false
        }
    }
})
